import './styles/OrderConfirmation.css';
import Header from '../../../index/components/Header/Header';
import Footer from '@/shared/components/footer/footer';
import MobileFooter from '@/shared/components/MobileFooter/MobileFooter';
import useIsMobile from '@/shared/hooks/useIsMobile';
import { useNavigate, useLocation } from 'react-router-dom';


const OrderConfirmation = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const { _id } = location.state || {};




  const handleViewOrder = () => {
    if (_id) {
      navigate(`/track-order/${_id}`);
    } else {
      alert('Order ID not available. Please check your orders from profile.');
    }
  };

  return (
    <div className="order-success-page">
      <Header />
      <div className="order-success-container">
        <div className="order-success-card">
          <div className="illustration-wrapper">
            <div className="check-circle">
              <div className="check-mark"></div>
              <img
                src="/images/logopreview.png"
                alt="Logo"
                className="logo-img"
              />
            </div>
          </div>

          {/* Heading */}
          <div className="heading-wrapper">
            <h1 className="order-heading">
              Thank you for Ordering !
            </h1>
            <img
              src="/images/logoname.png"
              alt="Logo Name"
              className="logo-name-img"
            />
          </div>

          {/* Description */}
          <p className="order-description">
            Your Order has been Placed Successfully.
          </p>

          {/* Buttons */}
          <div className="button-container">
            <button 
              className="btn-view-order"
              onClick={handleViewOrder}
            >
              VIEW ORDER
            </button>
            <button 
              className="btn-continue-shopping"
              onClick={() => navigate('/')}
            >
              CONTINUE SHOPPING
            </button>
          </div>
        </div>
      </div>
      {!isMobile && window.innerWidth > 1200 ? <Footer /> : <MobileFooter />}
    </div>
  );
};

export default OrderConfirmation;